module.exports = __webpack_public_path__ + "img/top.9a207f36.png";